import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CreatePostMutation } from "../graphql/mutations";
import type {
  CreatePostMutationType,
  CreatePostMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCreatePostMutation = (
  options?: MutationHookOptions<
    CreatePostMutationType,
    CreatePostMutationVariablesType
  >
) => {
  return useMutation<CreatePostMutationType, CreatePostMutationVariablesType>(
    CreatePostMutation,
    options
  );
};
